import React, {useState, useEffect} from 'react';
import {ProprietarioObject} from "../../models/Proprietario";
import {filtrarColecao} from "../../lib/utils";
import {actions} from "../../lib/app";
import {useAppDispatch, useAppSelector} from "../../lib/hooks";
import {useHistory} from "react-router";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {home} from "ionicons/icons";
import {EntityList} from "../../components/EntityListNG";
import FormProprietario from "./FormProprietario/FormProprietario";
import {useProprietariosUser} from "../../lib/DataHooks/proprietarios";
import {proprietarioCardSubtitle, proprietarioCardTitle, ProprietarioCardContent} from "./ProprietarioCard";
import {useFazendasIndexProprietarios} from "../../lib/DataHooks/fazendas";


interface ProprietariosProps {

}

const Proprietarios: React.FC<ProprietariosProps> = () => {
  const user = useAppSelector(state => state.app.user);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [criterio, setCriterio] = useState('');
  const [colecaoFiltrada, setColecaoFiltrada] = useState<ProprietarioObject[]>([]);

  const [colecao, loading] = useProprietariosUser(
    {userId: user.uid});

  const [indexProps, indexPropsIsLoading] = useFazendasIndexProprietarios({userId: user.uid});

  useEffect(() => {
    if (colecao && !loading) {
      setColecaoFiltrada(filtrarColecao(colecao, criterio, 'nome'));
    }
  }, [colecao, loading, criterio]);

  const _filtrarColecao = (criterio:string='') => {
    setCriterio(criterio);
  }

  const onClickInstance = (instance:ProprietarioObject) => {
    dispatch(actions.jump('/proprietarios'));
    history.push(`/proprietarios/${instance.id}/home`);
  };

  const cardContent = (i: ProprietarioObject) => (
    <ProprietarioCardContent
      user={user}
      proprietario={i}
      numFazendas={indexProps[i.id] ? indexProps[i.id].length : 0}
    />
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton/>
          </IonButtons>
          <IonTitle>
            Proprietários
          </IonTitle>
          <IonIcon
            icon={home}
            slot="primary"
            class="pr-3 text-2xl"
            onClick={() => history.push('/home')}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <EntityList
          entityLabel="proprietario"
          criterio={criterio}
          colecao={colecaoFiltrada}
          loading={loading || indexPropsIsLoading}
          filtrarColecao={_filtrarColecao}
          addEnabled={true}
          onClickInstance={onClickInstance}
          cardSubTitle={proprietarioCardSubtitle}
          cardTitle={proprietarioCardTitle}
          cardContent={cardContent}
          ModelForm={FormProprietario}
          modalNoPadding={true}
        />
      </IonContent>
    </IonPage>
  );
}

export default Proprietarios;
